import React, { useEffect, useRef } from "react";
import { compileMall, cssCol, shadeMall } from "../../lib/mallRegistry";
import { drawAvatar } from "../../lib/avatarDraw";

// Avatar contoh untuk pratinjau aksesoris (netral, tanpa aksesori dasar)
export const AVATAR_CONTOH = { kulit: "#f1c9a5", rambut: "pendek", warna_rambut: "#3b2a1a", baju: "#2e58c4", celana: "#3a3f4b", aksesori: [], mall: [] };
const TW = 64;

// Lukis satu perabot Mall ke kanvas: lantai tapak tipis + barang (kontrak ctx,P,U). cx,cy = pusat tapak w×d di layar.
export function lukisPerabotMall(ctx, fn, w, d, cx, cy, T, time = 0, tapak = true) {
  const hw = T / 2, hh = T / 4, ox = cx - ((w - d) * hw) / 2, oy = cy - ((w + d) * hh) / 2;
  const P = { top: [ox, oy], right: [ox + w * hw, oy + w * hh], bottom: [ox + (w - d) * hw, oy + (w + d) * hh], left: [ox - d * hw, oy + d * hh], height: T };
  if (tapak) { ctx.fillStyle = "rgba(20,20,20,.07)"; ctx.beginPath(); ctx.moveTo(...P.top); ctx.lineTo(...P.right); ctx.lineTo(...P.bottom); ctx.lineTo(...P.left); ctx.closePath(); ctx.fill(); }
  if (fn) fn(ctx, P, { tileW: T, w, d, zoom: T / TW, cssCol, shade: shadeMall, night: 0, time });
}

// Pratinjau barang Mall (perabot → diorama kecil; aksesoris → avatar contoh / avatar sendiri memakainya). Animasi ringan bila anim.
export function MallPreview({ item, code, size = 120, width, anim = false, avatar, bg = "transparent", testid, style }) {
  const ref = useRef(null);
  const kode = code ?? item?.paintCode;
  useEffect(() => {
    const c = ref.current; if (!c || !item) return undefined;
    const dpr = Math.min(2, window.devicePixelRatio || 1), W = width || size, H = size;
    c.width = Math.round(W * dpr); c.height = Math.round(H * dpr); c.style.width = `${W}px`; c.style.height = `${H}px`;
    const ctx = c.getContext("2d"), fn = compileMall(kode, item.jenis), t0 = performance.now();
    let raf;
    const gambar = () => {
      const t = (performance.now() - t0) / 1000;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H);
      if (bg !== "transparent") { ctx.fillStyle = bg; ctx.beginPath(); ctx.roundRect(0, 0, W, H, Math.min(W, H) * 0.14); ctx.fill(); }
      if (item.jenis === "aksesoris") {
        const s = (H - 10) / 60;
        drawAvatar(ctx, W / 2, H - 6, avatar || AVATAR_CONTOH, { scale: s, t, mallCoba: fn ? [{ fn, kategori: item.kategori }] : [] });
      } else {
        const w = item.w || 1, d = item.d || 1, lebar = (w + d) * (TW / 2) + 8, tinggi = (w + d) * (TW / 4) + TW * 1.0 + 12;
        const T = TW * Math.min((W - 8) / lebar, (H - 8) / tinggi);
        lukisPerabotMall(ctx, fn, w, d, W / 2, H - 6 - ((w + d) * (T / 4)) / 2, T, t);
      }
      if (!fn) { ctx.fillStyle = "rgba(20,20,20,.35)"; ctx.font = "700 10px 'Plus Jakarta Sans', sans-serif"; ctx.textAlign = "center"; ctx.fillText(kode ? "kode bermasalah" : "belum ada gambar", W / 2, H / 2); }
      if (anim) raf = requestAnimationFrame(gambar);
    };
    gambar();
    return () => cancelAnimationFrame(raf);
  }, [item, kode, size, width, anim, avatar, bg]);
  return <canvas ref={ref} data-testid={testid} style={{ display: "block", ...style }} aria-hidden />;
}
